import { ILlmSummarizeSectionsInput } from '../../utils/apollo/graphqlSchema';
import { LlmSummarySectionKey } from './useExplainEntityWithAiModel';
import SwitchiOS from '../SwitchiOS';
import {
  IconWrapper,
  SummarySectionLabel,
  SummarySectionsRow,
  SummarySectionsWrapper,
} from './ExplainWithAiResultUI';
import { MaybeNil } from '../../utils/interfaces';

interface IProps {
  sections: ILlmSummarizeSectionsInput;
  toggleSection: MaybeNil<(section: LlmSummarySectionKey) => void>;
}

const ExplainWithAiSummarySections = ({ sections, toggleSection }: IProps) => {
  return (
    <SummarySectionsWrapper>
      <SummarySectionsRow>
        <SummarySectionLabel>Executive summary:</SummarySectionLabel>
        <IconWrapper>
          <SwitchiOS
            isChecked={sections.executiveSummary}
            onClick={() => toggleSection?.('executiveSummary')}
          />
        </IconWrapper>
      </SummarySectionsRow>
      <SummarySectionsRow>
        <SummarySectionLabel>Key insights:</SummarySectionLabel>
        <IconWrapper>
          <SwitchiOS
            isChecked={sections.keyInsights}
            onClick={() => toggleSection?.('keyInsights')}
          />
        </IconWrapper>
      </SummarySectionsRow>
      <SummarySectionsRow>
        <SummarySectionLabel>Summary statistics:</SummarySectionLabel>
        <IconWrapper>
          <SwitchiOS
            isChecked={sections.summaryStatistics}
            onClick={() => toggleSection?.('summaryStatistics')}
          />
        </IconWrapper>
      </SummarySectionsRow>
      <SummarySectionsRow>
        <SummarySectionLabel>Recommendations:</SummarySectionLabel>
        <IconWrapper>
          <SwitchiOS
            isChecked={sections.recommendations}
            onClick={() => toggleSection?.('recommendations')}
          />
        </IconWrapper>
      </SummarySectionsRow>
    </SummarySectionsWrapper>
  );
};

export default ExplainWithAiSummarySections;
